import jump from 'jump.js';

document.addEventListener('alpine:init', () => {
  Alpine.data('donationsAppeal', (options) => {
    const appealPage = '.c-appeal-page';
    const transition = 1500;
    const formModuleSelector = '.donation--appeal';
    let isLargeScreen = false;
    let formModule;

    return {
      isAnimating: false,
      isLoaded: true,
      formExpand: options.formOnly,
      formFocus: options.formOnly,
      spotlightExpand: !options.formOnly,
      spotlightFocus: !options.formOnly,

      init() {
        formModule =
          this.$refs.donation &&
          this.$refs.donation.querySelector(formModuleSelector);

        this.listenToBrowserResize();
        this.isLoaded = "true";
      },

      listenToBrowserResize() {
        // Media query must match the `md` breakpoint in our stylesheets.
        const mql = window.matchMedia('screen and (min-width: 992px)');

        const handleChange = () => {
          isLargeScreen = mql.matches;
        };

        if (typeof mql.addEventListener === 'function') {
          mql.addEventListener('change', () => {
            handleChange();
          });
        } else if (typeof mql.addListener === 'function') {
          mql.addListener(() => {
            handleChange();
          });
        }

        handleChange();
      },

      appealFormFocus() {
        this.formFocus = true;

        this.setIsAnimating();

        setTimeout(() => {
          this.formExpand = true;
        }, 10);

        this.$nextTick(() => {
          jump(this.$refs.donation, {
            offset: -120,
            duration: transition,
            a11y: true,
          });
        });
      },

      appealContentFocus() {
        this.formExpand = false;

        this.setIsAnimating();

        this.$nextTick(() => {
          this.formFocus = false;
        });
      },
      setIsAnimating() {
        this.isAnimating = true

        this.$refs.appealGrid.addEventListener(
          'transitionend', e => {
            if (e.target == this.$refs.appealGrid) {
              this.isAnimating = false;
            }
          }
        )
      }
    };
  })
});

